import React from 'react';
import './ChangeSport.scss';
import __ from './../utils/translation';
import $ from "jquery";

import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&::before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor: 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
    ...theme.applyStyles('dark', {
        backgroundColor: 'rgba(255, 255, 255, .05)',
    }),
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

const Favorites = ({ canvas }) => {

    const [expanded, setExpanded] = React.useState('panel1');
    const [selectedValue, setSelectedValue] = React.useState('a');
    const [selectedBaseValue, setSelectedBaseValue] = React.useState('tradicional');
    const [selectedGolaValue, setSelectedGolaValue] = React.useState('Arsenal');
    const [selectedMangaValue, setSelectedMangaValue] = React.useState('curta');
    const [selectedPoseValue, setSelectedPoseValue] = React.useState('0');
    const [selectedShortValue, setSelectedShortValue] = React.useState('neutra');
    const [selectedBaseCorteValue, setSelectedBaseCorteValue] = React.useState('neutra');

    window["get_variant"] = function () {

        if (window.curentConjunto == "conjunto1") {
            return [
                selectedPoseValue,
                selectedBaseValue,
                selectedGolaValue,
                selectedMangaValue,
                selectedBaseCorteValue,
                selectedShortValue,
                $("#state-body-ra").prop("checked"),
                $("#state-socks-ra").prop("checked"),
                $("#state-shirt-ra").prop("checked"),
                $("#state-short-ra").prop("checked")
            ]
        } else {
            return [
                window.curentNewPoseValue,
                selectedBaseValue,
                selectedGolaValue,
                selectedMangaValue,
                selectedBaseCorteValue,
                selectedShortValue,
                $("#state-body-ra").prop("checked"),
                $("#state-socks-ra").prop("checked"),
                $("#state-shirt-ra").prop("checked"),
                $("#state-short-ra").prop("checked")
            ]
        }
    }

    window["set_variant"] = function () {
        setSelectedPoseValue(window.variantes[0]);
        setSelectedBaseValue(window.variantes[1]);
        setSelectedGolaValue(window.variantes[2]);
        setSelectedMangaValue(window.variantes[3]);
        setSelectedBaseCorteValue(window.variantes[4]);
        setSelectedShortValue(window.variantes[5]);
    }

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    const handleChangePose = (type) => (event, newExpanded) => {

        if (type.includes('conjunto')) {
            $("#download-poses").css("display", "flex");
        } else {
            $("#download-poses").css("display", "none");
        }

        window.curentConjunto = type;
        setSelectedPoseValue(event.target.value);
        window.currentPoseSelected = event.target.value;
        updateChanges(selectedBaseValue, selectedMangaValue, selectedGolaValue, event.target.value, false);
    };

    const handleChangeModel = (type, path, scaleAnim) => (event, newExpanded) => {

        if (path == "141" || path == "142" || path == "143") {
            $(".optionAce").css("visibility", "visible");
        } else {
            $(".optionAce").css("visibility", "hidden");
        }

        window.path = path;

        if (type.includes('conjunto')) {
            $("#download-poses").css("display", "flex");
            window.path = type + "/" + path;
        } else {
            $("#download-poses").css("display", "none");
        }

        if(type.includes("animados")){
            $("#menu-anim-controls").css("display", "block")
        }else{
            $("#st#menu-anim-controls").css("display", "none")
        }

        window.scaleAnim = scaleAnim;

        window.curentConjunto = type;
        setSelectedPoseValue(event.target.value);
        window.currentPoseSelected = event.target.value;

        window.curentNewPoseValue = path;

        updateChanges2(path);


        if (parseInt(event.target.value) > 80) {
            for (var i = 0; i < window.arrayLogic.length; i++) {
                window.arrayLogic[i].visible = false;
            }
        } else {
            for (var i = 0; i < window.arrayLogic.length; i++) {
                window.arrayLogic[i].visible = true;
            }
        }
    };

    const handleChangeBase = (event) => {
        setSelectedBaseValue(event.target.value);
        updateChanges(event.target.value, selectedMangaValue, selectedGolaValue, selectedPoseValue, true);
    };

    const handleChangeGola = (event) => {
        setSelectedGolaValue(event.target.value);
        updateChanges(selectedBaseValue, selectedMangaValue, event.target.value, selectedPoseValue, true);
    };

    const handleChangeManga = (event) => {
        setSelectedMangaValue(event.target.value);
        updateChanges(selectedBaseValue, event.target.value, selectedGolaValue, selectedPoseValue, true);
    };

    const handleChangeShort = (event) => {
        setSelectedShortValue(event.target.value);
        window.selectedShortValue = event.target.value;

        for (let i = 0; i < window.originalLayers.length; i++) {
            if (window.originalLayers[i].id == "corte_traseiro" || window.originalLayers[i].id == "corte_lateral_e" || window.originalLayers[i].id == "corte_lateral_d")
                window.originalLayers[i].visible = false;
        }


        for (var i = 0; i < window.currentPose.getObjectByName("short").children.length; i++) {
            window.currentPose.getObjectByName("short").children[i].material.alphaMap = null;
        }

        if (event.target.value == "neutra") {
            update();
            return;
        } else if (event.target.value == "barra") {
            for (var i = 0; i < window.currentPose.getObjectByName("short").children.length; i++) {
                window.currentPose.getObjectByName("short").children[i].material.transparent = true;
                window.currentPose.getObjectByName("short").children[i].material.alphaMap = window.alphaShort;
            }
            update();
            return;
        }

        for (let i = 0; i < window.originalLayers.length; i++) {
            if (event.target.value == "lateral") {
                if (window.originalLayers[i].id == "corte_lateral_e" || window.originalLayers[i].id == "corte_lateral_d")
                    window.originalLayers[i].visible = true;
            } else if (event.target.value == "traseiro") {
                if (window.originalLayers[i].id == "corte_traseiro")
                    window.originalLayers[i].visible = true;
            }
        }

        update();
    };

    const handleChangeBaseCorte = (event) => {
        setSelectedBaseCorteValue(event.target.value);

        for (let i = 0; i < window.originalLayers.length; i++) {
            if (window.originalLayers[i].id == "base_corte1" || window.originalLayers[i].id == "base_corte2")
                window.originalLayers[i].visible = false;
        }

        if (event.target.value == "neutra") {
            update();
            return;
        }

        for (let i = 0; i < window.originalLayers.length; i++) {
            if (window.originalLayers[i].id == "base_corte1" || window.originalLayers[i].id == "base_corte2")
                window.originalLayers[i].visible = true;
        }

        update();
    };

    function update() {
        window.fabricCanvas.requestRenderAll();
        setTimeout(() => {
            window["updateCanvas"]();
        }, 100);
    }

    function updateChanges(base, manga, gola, pose, variante) {

        $(".defaultPoses").css("display", "block");

        const path = base + "_" + manga + "_" + gola;

        window["loadParts"](
            "./models/pose" + pose + "/others.glb",
            "./models/pose" + pose + "/" + path + ".glb",
            variante,
            pose
        );
    }

    function updateChanges2(value) {

        $(".defaultPoses").css("display", "none");

        for (var i = window.currentPose.children.length - 1; i >= 0; i--) {
            window.currentPose.remove(window.currentPose.children[i]);
        }

        if (window.curentConjunto.includes("conjunto")) {
            window["loadParts"](
                null,
                "./models/new/" + window.curentConjunto + "/" + value + ".glb",
                true,
                1,
                false,
                true
            );
        } else {
            window["loadParts"](
                null,
                "./models/new/" + value + ".glb",
                true,
                1,
                false,
                true
            );
        }
    }
    return (
        <>
            <p className="title lang" data-en="FAVORITES" data-pt="FAVORITOS" data-es="FAVORITOS">{__('FAVORITOS')}</p>

            <div id="my-favorites">

            </div>

        </>
    )
}

export default Favorites